export function normalizeSegment(segment) {
  return { 'OPS-SW': 'OPS_SW', 'Grow@PLM': 'GROW_PLM' }[segment] || segment;
}

export function isSegmentEnabled(segment, enabledSegments) {
  return !enabledSegments || enabledSegments.some(value => normalizeSegment(value) === normalizeSegment(segment));
}

export function matchesSegment(sessionSegment, selectedSegment) {
  return !selectedSegment || normalizeSegment(sessionSegment) === normalizeSegment(selectedSegment);
}